import React from 'react';
import { Box, Skeleton } from '@mui/material';

const MListTabSkeleton = () => (
  <Box display="flex" pb={3} pl={3} pt={2}>
    <Box bgcolor="surface.white" mr={3} width={160}>
      <Box alignItems="center" display="flex" height="40px" justifyContent="space-between" px={1}>
        <Skeleton variant="text" width="55%" />
        <Skeleton height="20px" sx={{ borderRadius: '5px' }} variant="rectangular" width="60px" />
      </Box>
    </Box>
    <Box bgcolor="surface.white" mr={3} width={160}>
      <Box alignItems="center" display="flex" height="40px" justifyContent="space-between" px={1}>
        <Skeleton variant="text" width="55%" />
        <Skeleton height="20px" sx={{ borderRadius: '5px' }} variant="rectangular" width="60px" />
      </Box>
    </Box>
  </Box>
);

export default MListTabSkeleton;
